<template>
  <div
    class="modal"
    :id="modal.id"
    v-if="modal.show"
    :class="{ hide_header: modal.hideHeader }"
  >
    <aside>
      <section>
        <header class>
          <h3>{{ modal.heading }}</h3>
          <a @click.prevent="closeModal" class="close_button"></a>
        </header>
        <main>
          <slot></slot>
          <div v-html="modal.body"></div>
        </main>
        <footer v-if="hasfooter">
          <slot name="footer"></slot>
        </footer>
      </section>
    </aside>
  </div>
</template>

<script>
export default {
  props: ["modal"],
  methods: {
    closeModal() {
      this.$set(this.modal, "show", false);
    }
  },
  watch: {
    "modal.show": {
      handler: function(newVal) {
        let b = document.getElementsByTagName("body")[0];
        if (newVal) {
          b.classList.add("show_modal");

          // setTimeout(() => {
          //   let findFocus = document.getElementsByClassName("focus");
          //   console.log("findFocus", findFocus);

          //   for (
          //     let i = 0, len = findFocus.length | 0;
          //     i < len;
          //     i = (i + 1) | 0
          //   ) {
          //     findFocus[i].focus();
          //     findFocus[i].classList.add("findFocus");
          //   }
          // }, 900);
        }
        //
        else {
            b.classList.remove("show_modal");
        }
      },
      immediate: true
    }
  },
  computed:{
    hasfooter(){
      return (undefined != this.$slots.footer);
    }
  },
  beforeDestroy() {
    //alert("beforeDestroy");
    let b = document.getElementsByTagName("body")[0];
    let findModals = document.getElementsByClassName("modal");
    //alert("beforeDestroy findModals: " + findModals.length);
    if (findModals.length === 0) {
      b.classList.remove("show_modal");
    }
    //
    else {
      //b.classList.add("show_modal");
    }
  },
  mounted() {}
};
</script>

<style></style>
